import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import api from '../lib/api'
import { getToken, setToken, getAdmin, setAdmin, clearAuth } from '../lib/auth'

export const useAuthStore = defineStore('auth', () => {
  const token = ref(getToken())
  const admin = ref(getAdmin())

  const isAuthenticated = computed(() => !!token.value)
  const adminName = computed(() => admin.value?.name || '')
  const role = computed(() => admin.value?.role || null)

  const isRoot = computed(() => role.value === 'ROOT')
  const isAdmin = computed(() => role.value === 'ADMIN')
  const isCheckin = computed(() => role.value === 'CHECKIN')
  const encontroId = computed(() => admin.value?.encontroId ?? null)
  const isGlobalRoot = computed(() => isRoot.value && encontroId.value === null)

  const canManageAdmins = computed(() => isRoot.value)
  const canResetEncontro = computed(() => isRoot.value)
  const canManageParticipants = computed(() => isRoot.value || isAdmin.value)
  const canSeeFinanceiro = computed(() => isRoot.value || isAdmin.value)

  async function login(email, password) {
    const response = await api.post('/auth/login', { email, password })
    token.value = response.data.token
    admin.value = response.data.admin
    setToken(response.data.token)
    setAdmin(response.data.admin)
    return response.data
  }

  async function refresh() {
    try {
      const { data } = await api.get('/auth/me')
      admin.value = data.admin
      setAdmin(data.admin)
    } catch {
      // Token invalido sera tratado pelo interceptor
    }
  }

  function logout() {
    token.value = null
    admin.value = null
    clearAuth()
  }

  return {
    token, admin,
    isAuthenticated, adminName, role, encontroId,
    isRoot, isAdmin, isCheckin, isGlobalRoot,
    canManageAdmins, canResetEncontro, canManageParticipants, canSeeFinanceiro,
    login, logout, refresh
  }
})
